import { generateUseContext } from '@guiker/react-framework'

import { ServicesScreenContext } from './ServicesScreenContext'

export const useServicesScreenContext = generateUseContext(ServicesScreenContext)
